/**
 * @export
 * @class Blocks
 */
import { getAll } from '../helpers/utilities';

import { ApplicationBlock } from './application-block';
import { ContentSwitcher } from './content-switcher';
import { OverlayBox } from './overlay-box';
import { ProductsSplit } from './products-split';

export class Blocks {

    // Our Block Classes
    private static classes: any[] = [ ContentSwitcher, OverlayBox, ProductsSplit, ApplicationBlock ];


    /**
     * Loops through our classes, and initiates a new instance for each element.
     */
    constructor() {
        Blocks.classes.forEach(blockClass => {
            if(blockClass.selector) {
                const selector = blockClass.selector;
                const elements = getAll(selector);
                if(elements) {
                    elements.forEach(element => {
                        new blockClass(element);
                    });
                }
            }
        });
    }
}
